import clsx from "clsx";
import { ReactNode } from "react";

import { Info } from "@/assets/icons/icons";

interface BannerProps {
  className?: string;
  children: ReactNode;
}

export const Banner = ({ className, children }: BannerProps) => {
  return (
    <div
      className={clsx(
        "flex items-center gap-6 rounded-sm bg-primary-25 px-4 py-2 text-primary-100",
        className,
      )}
    >
      <Info className="h-6 w-6 shrink-0" />
      <p className="text-base">{children}</p>
    </div>
  );
};
